<template>
  <div id="app">
    <div class="main">

      <div class="navigation">
          <b-navbar toggleable="lg" type="dark" variant="info">
              <b-navbar-brand to="/">Home</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse">
                 <!-- <b-badge pill variant="danger" v-show="ordersUpdate || recieptsUpdate || cartUpdate">!!!!!</b-badge> -->
              </b-navbar-toggle>

              <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                  <b-nav-item to="/shop">Shop</b-nav-item>
                    <b-nav-item to="/orders">
                      Orders 
                      <b-badge pill variant="primary" v-show="ordersUpdate">!</b-badge>
                    </b-nav-item>
                    <b-nav-item to="/receipts">
                      Receipts 
                      <b-badge pill variant="primary" v-show="recieptsUpdate">!</b-badge>
                    </b-nav-item>
                    <b-nav-item to="/cart">Your Cart 
                      <b-badge pill variant="primary" v-show="cartUpdate">!</b-badge>
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template v-slot:button-content>
                        <em>User</em>
                    </template>
                    <b-dropdown-item href="/profile">Profile</b-dropdown-item>
                    <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
              </b-collapse>
          </b-navbar>
      </div>

      <b-container fluid>
        <router-view></router-view>
      </b-container>

    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  computed : {
    ordersUpdate() {
      return this.$store.getters.ORDERS_UPDATES
    },
    recieptsUpdate() {
      return this.$store.getters.RECIEPTS_UPDATES
    },
    cartUpdate() {
      return this.$store.getters.CART_UPDATES
    },
  },
  mounted() {
    this.$store.dispatch('GET_USER').then(() => {
        this.$store.dispatch('GET_STORES').then(() => {
          if(this.$router.currentRoute.path !== '/') this.$router.push('/')
        })
    })
  },
  methods: {
    logout: function () {
      this.$store.dispatch('AUTH_LOGOUT')
      .then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.status {
  color: black;
  font-style: italic;
  font-weight: bold;
}
.not-accepting-orders {
  color: red;
}
</style>
